export default __webpack_public_path__ + "static/media/self-print.957d6d2e.svg";